/* eslint-disable indent */
import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { FormGroup, NgForm } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar';
import { FinanciadoraModel } from 'src/app/dominio/financiadora-model';
import { FinPropostaTipoCriacao } from 'src/app/models/enum';
import { FinProposta } from 'src/app/models/fin-proposta';
import { FinSimulacao } from 'src/app/models/fin-simulacao';
import { Financiadora } from 'src/app/models/financiamento/financiadora';
import { IntegradorFinanciadoraSimples } from 'src/app/models/financiamento/integrador-financiadora-simples';
import { CarregandoService } from 'src/app/services/carregando.service';
import { FinSimulacaoService } from 'src/app/services/fin-simulacao.service';
import { FinanciamentoService } from 'src/app/services/financiamento.services';
import { NotificacaoService } from 'src/app/services/notificacao.service';
import { FinanciadoraService, HubConfigSchema } from '../../services/financiadora.service';
import { QueryFilterService } from 'src/app/core/services/query-filter-service';
import { FormlyFormOptions, FormlyFieldConfig } from '@ngx-formly/core';
import { FormlyJsonschema } from '@ngx-formly/core/json-schema';

@Component({
  selector: 'app-cadastrar-fin-proposta',
  templateUrl: './cadastrar-fin-proposta.component.html',
  styleUrls: ['./cadastrar-fin-proposta.component.scss']
})
export class CadastrarFinPropostaComponent implements OnInit {

  proposta: FinProposta = new FinProposta();

  financiadoras: FinanciadoraModel[] = [];
  financiadoraSelecionada: FinanciadoraModel;

  financiadorasParaSimular: FinanciadoraModel[] = [];

  simulacao: FinSimulacao;

  propostaParaSimular = { valor: undefined, valorEntrada: undefined };

  public config: PerfectScrollbarConfigInterface = {};

  novaSimulacao = false;

  editando = false;

  tipoSimulacao = 0; // 0 - manual | 1 - gateway

  opcaoSeguro= [{ id: false, descricao: 'Não' }, { id: true, descricao: 'Sim' }];

  configSchema: HubConfigSchema;

  formlyConfigForm: FormGroup = new FormGroup({});
  formlyOptions: FormlyFormOptions;
  formlyFields: FormlyFieldConfig[];
  formlyModel = {};
  somentePropostasComSeguro = false;

  idTarefa: number;

  @ViewChild('formFinProposta', { static: true }) form: NgForm;

  constructor(private carregandoService: CarregandoService, private notificacaoService: NotificacaoService,
    private finSimulacaoService: FinSimulacaoService, private financiamentoService: FinanciamentoService,
    private dialogRef: MatDialogRef<CadastrarFinPropostaComponent>, @Inject(MAT_DIALOG_DATA) public data: any,
    private financiadoraService: FinanciadoraService,
    private queryFilterService: QueryFilterService,
    private formlyJsonschema: FormlyJsonschema,
  ) { }

  async ngOnInit() {

    this.simulacao = this.data.simulacao;
    await this.buscarFinanciadoras();

    this.idTarefa = this.data.idTarefa;

    if (this.data.idFinanciadora) {
      this.financiadoraSelecionada = this.financiadoras.find(p => p.id === this.data.idFinanciadora);
    }

    if (this.data.proposta) {
      this.proposta = this.data.proposta;
      this.editando = true;
    }

    if (this.proposta.valorSolicitado === null || this.proposta.valorSolicitado === undefined) {
      this.proposta.valorSolicitado = this.simulacao.valor;
    }

    if (this.proposta.valorEntrada === null || this.proposta.valorEntrada === undefined) {
      this.proposta.valorEntrada = this.simulacao.valorEntrada;
    }
  }

  async buscarFinanciadoras() {
    try {
      this.carregandoService.mostra('buscarFinanciadoras');

      const queryFilter = this.queryFilterService
        .getQueryBuilder()
        .addOrderBy("nome")
        .build();

      this.financiadoras = (await this.financiadoraService.buscarTodosV2(queryFilter).toPromise()).results;
      this.financiadorasParaSimular = this.financiadoras.filter(p => p.ativo);
    } catch (erro) {
      this.notificacaoService.erro(erro);
    } finally {
      this.carregandoService.esconde('buscarFinanciadoras');
    }
  }

  async buscarConfigSchema() {
    try {
      this.carregandoService.mostra('buscarConfigSchema');

      const configOctopus = (await this.financiadoraService.buscarConfigOctopus(this.financiadoraSelecionada.id).toPromise()).results;
      this.configSchema = (await this.financiadoraService.buscarSchemaConfig(this.financiadoraSelecionada.id).toPromise()).result;

      const fieldConfig = this.formlyJsonschema
        .toFieldConfig(JSON.parse(this.configSchema.configSchema), {
          map: (mappedField) => {
            // mappedField.templateOptions.disabled = true;

            return mappedField;
          }
        });

      this.formlyFields = [fieldConfig];
      this.formlyModel = configOctopus.some(p => p.idCategoria === 108) ? JSON.parse(configOctopus.find(p => p.idCategoria === 108).configModel) : {};

    } catch (erro) {
      this.notificacaoService.erro(erro);
    } finally {
      this.carregandoService.esconde('buscarConfigSchema');
    }
  }

  async salvarProposta() {
    try {

      if (this.financiadoraSelecionada === null || this.financiadoraSelecionada === undefined ||
        !this.financiadoraSelecionada.ativo)
        return;

      if (this.tipoSimulacao === 0) {
        if (!this.form.valid) return;
      } else {
        if (!this.formlyConfigForm.valid) return;
      }


      if (this.proposta.totalEmprestimo !== null && this.proposta.totalEmprestimo !== undefined && this.proposta.totalEmprestimo.toString() == '') {
        this.proposta.totalEmprestimo = null;
      }

      this.proposta.idFinanciadora = this.financiadoraSelecionada.id;

      if (!this.editando) {
        this.proposta.tipoCriacao = this.tipoSimulacao === 0 ? FinPropostaTipoCriacao.Manual : FinPropostaTipoCriacao.Gateway;

        if (this.tipoSimulacao === 0) {
          this.carregandoService.mostra('salvarProposta');
          await this.finSimulacaoService.cadastrarPropostaV2(this.idTarefa, this.proposta).toPromise();
          this.notificacaoService.sucesso('Proposta salva com sucesso!!!');
        }
        else {
          this.carregandoService.mostra('salvarProposta');
          await this.financiadoraService.cadastrar(this.idTarefa, this.financiadoraSelecionada.id, this.somentePropostasComSeguro, JSON.stringify(this.formlyModel)).toPromise();
          this.notificacaoService.sucesso('Proposta salva com sucesso!!!');
        }

        this.dialogRef.close(true);

      } else {
        this.carregandoService.mostra('salvarProposta');
        await this.finSimulacaoService.atualizarPropostaV2(this.idTarefa, this.proposta).toPromise();
        this.notificacaoService.sucesso('Proposta salva com sucesso!!!');
        this.dialogRef.close(true);
      }
    } catch (erro) {
      this.notificacaoService.erro(erro);
    } finally {
      this.carregandoService.esconde('salvarProposta');
    }
  }

  async simular() {
    try {
      this.carregandoService.mostra('simular');
      await this.finSimulacaoService.simular(this.simulacao.id, this.financiadoraSelecionada.id, this.propostaParaSimular.valor, this.propostaParaSimular.valorEntrada).toPromise();
      this.notificacaoService.sucesso('Simulação solicitada com sucesso!!!');
      this.dialogRef.close(true);
    } catch (erro) {
      this.notificacaoService.erro(erro);
    } finally {
      this.carregandoService.esconde('simular');
    }
  }

  async alterouFinanciadora() {
    this.novaSimulacao = false;

    if (this.financiadoraSelecionada.gateway && !this.financiadoraSelecionada.podeEnviarPropostaManual && this.tipoSimulacao === 0) {
      this.tipoSimulacao = 1;
    } else if (!this.financiadoraSelecionada.gateway && this.tipoSimulacao === 1) {
      this.tipoSimulacao = 0;
    }

    await this.alterouTipo();
  }

  async alterouTipo() {
    switch (this.tipoSimulacao) {
      case 0:
        this.configSchema = undefined;
        this.somentePropostasComSeguro = false;
        this.formlyModel = {};
        break;

      case 1:
        await this.buscarConfigSchema();
        break;
    }
  }

  fazerNovaSimulacao() {
    this.novaSimulacao = true;
    this.propostaParaSimular = { valor: undefined, valorEntrada: undefined };
  }

  fechar() {
    this.dialogRef.close();
  }

  calcularValorTotal() {
    this.proposta.totalEmprestimo = Number(this.proposta.qtdParcelas) * Number(this.proposta.valorParcela);
  }

  calcularValorLiberado() {
    this.proposta.valorLiberado = Number(this.proposta.valorSolicitado) - Number(this.proposta.valorEntrada);
  }

}
